import { computed, defineComponent, inject, onMounted, ref } from 'vue';
import CandidatesList from '@/sections/client/candidates/candidates-list/CandidatesList.vue';
import CandidatesFilter from '@/sections/client/candidates/candidates-filter/CandidatesFilter.vue';
import StemdoerService from '@/sections/admin/entities/stemdoer/stemdoer.service';
import { IStemdoer } from '@/shared/model/stemdoer.model';
import { useStore } from '@/plugins/vuex';
import NoContent from './no-content/noContent.vue';

export default defineComponent({
  components: {
    CandidatesList,
    CandidatesFilter,
    NoContent
  },
  setup() {
    const store = useStore();
    const stemdoerService: StemdoerService = inject('stemdoerService');
    const candidates = ref<IStemdoer[]>([]);
    const isLoading = ref(true);
    const isCandidateListEmpty = ref(true);
    const search = ref('');
    const companySelected = computed(() => store.getters['cartStore/companySelected']);

    const preferredVerticals = computed(() => {
      const account = store.getters['account'];
      return account && account.preferredVerticals ? account.preferredVerticals : [];
    });

    onMounted(() => {
      retrieveCandidates();
    });

    const retrieveCandidates = async () => {
      const companyCif = companySelected.value.cif;
      const currentDate = new Date();
      const preferred = preferredVerticals.value;
      const preferredIds = preferred && preferred.length > 0 ? preferred.map(v => v.id) : undefined;
      const response = await stemdoerService.retrieveStemdoersByCompanyProjects(companyCif, currentDate, preferredIds);
      candidates.value = response.data || response;
      isCandidateListEmpty.value = candidates.value.length == 0;
      isLoading.value = false;
    };

    const filteredCandidates = computed(() => {
      if (!search.value) return candidates.value;
      const searchValue = search.value.toLowerCase().trim();
      const isRateSearch = /^\d+€?$/.test(searchValue);
      return candidates.value.filter(candidate => {
        const fullName = `${candidate.name} ${candidate.surname}`.toLowerCase();
        const position = candidate.position ? candidate.position.toLowerCase() : '';
        const rate = candidate.projects.length > 0 && candidate.projects[0].rate ? candidate.projects[0].rate.toString() : '';
        if (isRateSearch) {
          const normalizedRate = rate.replace(' €', '').trim();
          return normalizedRate.includes(searchValue.replace(' €', '').trim());
        }
        return fullName.includes(searchValue) || position.includes(searchValue) || rate.includes(searchValue);
      });
    });

    return {
      candidates,
      isLoading,
      isCandidateListEmpty,
      search,
      filteredCandidates
    };
  }
});
